import { AppController } from "../AppController";
var UserErrorPage = /** @class */ (function () {
    function UserErrorPage(_appController) {
        this._appController = _appController;
    }
    Object.defineProperty(UserErrorPage.prototype, "appController", {
        get: function () {
            return this._appController;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UserErrorPage.prototype, "errorMessage", {
        get: function () {
            return this._appController.latestErrorMessage;
        },
        enumerable: true,
        configurable: true
    });
    return UserErrorPage;
}());
export { UserErrorPage };
